'use client';

import { useRouter } from 'next/navigation';

import { firebaseAuthClient } from '@/src/modules/auth/auth.config';
import { IAPIResponse } from '@/src/types/api';

export const useHeaderAccount = () => {
  const router = useRouter();

  const signOut = async () => {
    try {
      await firebaseAuthClient.signOut();
      router.refresh();
      /*
      const response = await fetch('/api/auth/sign-out', {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const resBody =
        (await response.json()) as unknown as IAPIResponse<string>;
      if (response.ok && resBody.success) {
        router.refresh();
      } else return false;

       */
    } catch (error) {
      console.error('Error signing out with Google', error);
      return false;
    }
  };

  return {
    signOut,
  };
};
